import { Typography } from '@material-ui/core';
import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import {
    Button,
    Navbar,
    NavbarBrand,
    Nav,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import theme from '../../theme';
import { Environment } from 'environmentVariables';
import ImpersonationCheck from './ImpersonationCheck';

class Navigation extends Component {
    constructor(props) {
        super(props);
    }

    handle_logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        window.location.reload();
    }

    render() {
        return (
            <Navbar color="light" light expand="md" style={{ marginBottom: '0' }}>
                <ImpersonationCheck />
                <NavbarBrand>
                    <NavLink to="/adminperson/businesses">Tandem</NavLink>
                </NavbarBrand>
                {Environment === 'production' && (
                    <Typography variant="h6" style={{ color: theme.palette.error.main }}>
                        <b>YOU ARE IN PRODUCTION!</b>
                    </Typography>
                )}
                <Nav className="ml-auto" navbar>
                    <div style={{ marginRight: 2 }}>
                        <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="nav-link" caret>
                                Home
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/businesses">
                                        Businesses
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/businesses/download">
                                        Businesses Download
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/region-map">
                                        Region Map
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/biz-map">
                                        Business Map
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/provider-map">
                                        Provider Map
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/highlight-jobs">
                                        Highlight Jobs
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/providers">
                                        Providers
                                    </NavLink>
                                </DropdownItem>

                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/applicant-approval">
                                        Applicant Feed
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/sales-leads">
                                        Sales Leads
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/substitutes">
                                        Substitutes
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/share-provider">
                                        Share Providers
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/scheduled-jobs/2">
                                        Manage Scheduled Jobs
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/documents-verify">
                                        Verify Documents
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/background-check-verify">
                                        Verify Background Checks
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/label-loss-reasons">
                                        Label User Loss Reasons
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/autobook-history">
                                        Autobook History
                                    </NavLink>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                    <div style={{ marginRight: 2 }}>
                        <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="nav-link" caret>
                                Matching
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/substitutes">
                                        Substitutes
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/applicant-approval">
                                        Applicant Feed
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/matching/inbox">
                                        Matching Inbox
                                    </NavLink>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                    <div style={{ marginRight: 2 }}>
                        <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="nav-link" caret>
                                Flags
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/flag-review">
                                        Review
                                    </NavLink>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                    <div style={{ marginRight: 2 }}>
                        <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="nav-link" caret>
                                Payments
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/dashboard">
                                        Dashboard
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/overdue">
                                        Overdue Payments
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/customers">
                                        Customers
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/invoices">
                                        Invoices
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/paystubs">
                                        Pay Stubs
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/pay-provider">
                                        Pay Provider
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/approve-hours">
                                        Approve Hours
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/group-pays">
                                        Group Pays
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/pq-hooks">
                                        PQ Webhooks
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/advances">
                                        TandemPay Advances
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/reviews">
                                        Stripe Reviews
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/blocked/invoices">
                                        Blocked Invoices
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/payments/blocked/paystubs">
                                        Blocked PayStubs
                                    </NavLink>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                    <NavLink style={styles.link} to="/adminperson/impersonate">
                        Impersonate
                    </NavLink>
                    <div style={{ marginRight: 2 }}>
                        <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="nav-link" caret>
                                Outreach
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/outreach/indeed-post">
                                        Post on Indeed
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/outreach/email">
                                        Email Outreach
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/email">
                                        Send Emails
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/unsubscribe">
                                        Unsubscribe
                                    </NavLink>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                    <div style={{ marginRight: 2 }}>
                        <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="nav-link" caret>
                                Texting
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/texting">
                                        Families
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/sitter-texting">
                                        Sitters
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/filtering">
                                        Public Application Filtering
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/outreach-new">
                                        Outreach - New
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/messages">
                                        Messages
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/message-table">
                                        User Message Threads
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/business-message-table">
                                        Business Message Threads
                                    </NavLink>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                    <div style={{ marginRight: 2 }}>
                        <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="nav-link" caret>
                                Notify People
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/push-notifications">
                                        Push it
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink style={styles.link} to="/adminperson/mass-text">
                                        Text it
                                    </NavLink>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                    <Button
                        size="sm"
                        style={{ marginTop: 6 }}
                        outline
                        color="secondary"
                        onClick={() => this.handle_logout()}
                    >
                        Logout
                    </Button>
                </Nav>
            </Navbar>
        );
    }
}

export default withRouter(Navigation);

let styles = {
    link: {
        marginTop: 8,
        marginRight: 10,
        color: 'gray',
        fontFamily: 'Work Sans',
    },
};
